import { FieldObjectType } from 'module/api/field/types';
import { useTranslation } from 'module/hooks/use-translation';
import { FontAwesomeIcon } from 'module/ui/components/atoms/icon/icon';
import { PageLoading } from 'module/ui/components/atoms/loading';
import { ActionBar } from 'module/ui/components/molecules/action-bar';
import { HeaderWithIconTitle } from 'module/ui/components/molecules/page/page';
import { Argon as ArgonTemplate } from 'module/ui/components/templates/argon';
import { Content } from 'module/ui/components/templates/argon/components';
import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { faBarsStaggered } from '@fortawesome/pro-solid-svg-icons';
import { Button } from '@rocketlane/ui';
import { useGetAllSignalFieldsQuery } from 'queries/fields';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { SignalFieldsList } from 'components/organisms/signal-fields/list';
import { ManageFieldDrawer } from 'components/organisms/signal-fields/manage-field-drawer';
import { useManageFieldDrawerState } from 'components/organisms/signal-fields/manage-field-state';

const Argon = styled(ArgonTemplate)`
  ${Content} {
    border: none;
  }
  ${ActionBar} {
    box-shadow: none;
  }
`;

export const SignalFieldsPage = () => {
  const title = useTranslation('signal_fields');
  const { data: signalFields, isLoading: isSignalFieldsLoading } =
    useGetAllSignalFieldsQuery({
      select: (data) =>
        data.filter((field) => field.objectType === FieldObjectType.Signal),
    });
  const {
    drawerState,
    closeDrawer,
    openDrawerInCreateMode,
    openDrawerInEditMode,
  } = useManageFieldDrawerState();

  return (
    <Argon
      documentTitle={title}
      title={
        <HeaderWithIconTitle
          icon={<FontAwesomeIcon icon={faBarsStaggered} size={20} />}
          title={title}
        />
      }
      description={<FormattedMessage id="settings.signal_fields.description" />}
      actions={
        isSignalFieldsLoading
          ? {}
          : {
              secondary: (
                <Button
                  leftIcon={<FontAwesomeIcon icon={faPlus} />}
                  variant="primary"
                  onClick={openDrawerInCreateMode}
                >
                  <FormattedMessage id="settings.signal_fields.create_field" />
                </Button>
              ),
            }
      }
      content={
        isSignalFieldsLoading ? (
          <PageLoading />
        ) : (
          <>
            <SignalFieldsList
              fields={signalFields ?? []}
              onEdit={openDrawerInEditMode}
            />
            <ManageFieldDrawer
              onClose={closeDrawer}
              visible={drawerState.visible}
              field={drawerState.field}
              fieldObjectType={FieldObjectType.Signal}
            />
          </>
        )
      }
    ></Argon>
  );
};
